/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_4_Before_Consent_DescInputs */

const en_privacy_section_4_before_consent_desc = /** @type {(inputs: Privacy_Section_4_Before_Consent_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ad_storage and analytics_storage are denied by default. No tracking cookies are set until you explicitly accept`)
};

const lv_privacy_section_4_before_consent_desc = /** @type {(inputs: Privacy_Section_4_Before_Consent_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ad_storage un analytics_storage pēc noklusējuma ir liegti. Izsekošanas sīkdatnes netiek iestatītas, kamēr neesat skaidri devis piekrišanu`)
};

/**
* | output |
* | --- |
* | "ad_storage and analytics_storage are denied by default. No tracking cookies are set until you explicitly accept" |
*
* @param {Privacy_Section_4_Before_Consent_DescInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_4_before_consent_desc = /** @type {((inputs?: Privacy_Section_4_Before_Consent_DescInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_4_Before_Consent_DescInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_4_before_consent_desc(inputs)
	return en_privacy_section_4_before_consent_desc(inputs)
});